import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const fetcher = () => TablaComunService.getAsSelect(TiposTablaComunConstant.DETRACCION).then(({ data }) => data)

const DetraccionSelect = props => {
  const { data: detracciones } = useSwr('select_detraccion', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {detracciones.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(DetraccionSelect)
